import { Step } from 'src/app/model/firm/onboarding/onboarding-step.model';

export enum StepPath {
  FIRM = "firm-onboarding",
  TEAM = "teams-onboarding",
  CLIENT = "client-onboarding",
  // CLIENT_INTEGRATION = "client-integration",
  COMPONENTS = "components-onboarding",
  ACTIVATE_LUKA = "luka-onboarding",
  ENGAGEMENT = "engagement-overview",
}

export enum StepRoute {
  FIRM = "/getting-started/firm-onboarding",
  TEAM = "/getting-started/teams-onboarding",
  CLIENT = "/getting-started/client-onboarding",
  // CLIENT_INTEGRATION = "/getting-started/client-integration",
  COMPONENTS = "/getting-started/components-onboarding",
  LUKA = "/getting-started/luka-onboarding",
  ENGAGEMENT = "/getting-started/engagement-overview",
}

export const STEP_ORDER: StepPath[] = [
  StepPath.FIRM,
  StepPath.TEAM,
  StepPath.CLIENT,
  // StepPath.CLIENT_INTEGRATION,
  StepPath.COMPONENTS,
  StepPath.ACTIVATE_LUKA,
  StepPath.ENGAGEMENT,
];

export const Steps: Step[] = [
  {
    id: 1,
    path: StepPath.FIRM,
    title: "Add Firm Info",
    description: "Enter your firm information",
    footer: "You can update details anytime from your account profile.",
    route: `/getting-started/${StepPath.FIRM}`
  },
  {
    id: 2,
    path: StepPath.TEAM,
    title: "Add Team",
    description: "Add team members to collaborate",
    footer: "Update team details anytime in Edit Team Member.",
    route: `/getting-started/${StepPath.TEAM}`
  },
  {
    id: 3,
    path: StepPath.CLIENT,
    title: "Add Client",
    description: "Add client to begin engagements",
    footer: "Update client information anytime under Client section.",
    route: `/getting-started/${StepPath.CLIENT}`
  },
  // {
  //   id: 4,
  //   path: StepPath.CLIENT_INTEGRATION,
  //   title: "Client Integration Setup",
  //   description: "Connect client to integration",
  //   footer: "You can connet the client to the integration anytime under clinet section.",
  // },
  {
    id: 4,
    path: StepPath.COMPONENTS,
    title: "Header, Footer, Signature & Logo",
    description: "Set up your firm's branding",
    footer: "Manage header, footer, and signature anytime under the settings.",
    route: `/getting-started/${StepPath.COMPONENTS}`
  },
  {
    id: 5,
    path: StepPath.ACTIVATE_LUKA,
    title: "Activate Luka",
    description: "Supercharge your workflow with AI",
    footer: "Activation controls are always available under Billing in your Settings panel",
    route: `/getting-started/${StepPath.ACTIVATE_LUKA}`
  },
  {
    id: 6,
    path: StepPath.ENGAGEMENT,
    title: "Engagement Workflow Overview",
    description: "Manage engagements with ease",
    footer: "",
    route: `/getting-started/${StepPath.ENGAGEMENT}`
  },
];

export enum StepSequence {
  FIRM = 0,
  TEAM = 1,
  CLIENT = 2,
  COMPONENTS = 3,
  ENGAGEMENT = 4
}
